/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { BaseResponse } from '../../models/base-response';
import { WarehouseMovementSerialsListResponse } from '../../models/warehouse-movement-serials-list-response';

export interface WarehouseControllerFindSerialsByWarehouseMovement$Params {
  id: number;
}

export function warehouseControllerFindSerialsByWarehouseMovement(http: HttpClient, rootUrl: string, params: WarehouseControllerFindSerialsByWarehouseMovement$Params, context?: HttpContext): Observable<StrictHttpResponse<BaseResponse & {
'data'?: WarehouseMovementSerialsListResponse;
}>> {
  const rb = new RequestBuilder(rootUrl, warehouseControllerFindSerialsByWarehouseMovement.PATH, 'get');
  if (params) {
    rb.path('id', params.id, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<BaseResponse & {
      'data'?: WarehouseMovementSerialsListResponse;
      }>;
    })
  );
}

warehouseControllerFindSerialsByWarehouseMovement.PATH = '/warehouse/movements/{id}/serials';
